import { ThemeUICSSObject, spacing } from '@apia/theme';
/* IMPORT HERE */

const verify: ThemeUICSSObject = {
  '.modal__main main.modal__content': {
    justifyContent: 'center',
  },

  '*': { minWidth: 'max-content' },

  table: {
    minWidth: '550px',
    borderCollapse: 'collapse',
    border: '1px solid',
    borderColor: 'primary',

    th: {
      p: spacing(6),
      px: 7,
      bg: 'primary',
      color: 'white',
      whiteSpace: 'nowrap',
    },

    td: {
      p: spacing(4),
      px: 7,
      textAlign: 'center',

      button: {
        margin: 'auto',

        '&.iconButton': {
          px: 4,
        },
      },
    },

    tr: {
      '&:nth-of-type(2n)': {
        bg: 'oddRow',
      },
    },
  },
  /* PREPEND HERE */
};

export default verify;
